// @ts-nocheck

import React from 'react'
import { Container, Nav, NavItem, Navbar, Button} from 'react-bootstrap'
import qs from 'query-string'
import { useAuth0Login } from 'modules/useAuth0Login'
import { prepareAuth0Redirect } from 'modules/landingUrl'
import {
  siteLinkUrl,
  siteLogoStyles,
} from 'modules/siteContents'
import { constructRedirectUri } from 'modules/utils'
import queryString from 'query-string'
import { MainImage } from './MainImage'
import { HeaderNavigationDropDown } from './HeaderNavigationDropdown'

export const HeaderFEW = (props) => {
  const { saveAppState, email, isAdmin, search, successInfo, site, isAdminTerminal, utmCampaign, mainImage, initialUrlParams } = props
  const { loginWithRedirect, loginWithPopup, user } = useAuth0Login()
  const redirectUri = constructRedirectUri(qs.parse(search), location.pathname)

  return (
    <div id="header">
      <style type="text/css">
        {`.navbar-brand img {
            height: 64px;
            width: 64px;
          }
        `}
      </style>
      <Navbar collapseOnSelect style={{ marginBottom: 0, padding: 0 }}>
        <Container fluid style={{ minHeight: 93, maxHeight: 'none', paddingLeft: 64, paddingRight: 64, }}>
          <div className="navbar-header inline-flex">
            <div className="flex v-center" style={{ height: 86 }}>
              <Navbar.Brand>
              <a href={siteLinkUrl[site] || null} style={{ paddingRight: 16 }}>
                <img 
                  width="350" height="42" 
                  style={siteLogoStyles[site]}
                  src="/server/assets/images/Round-Green-Logo_comp-150x150.png" 
                  alt="" decoding="async" 
                  // srcSet="/server/assets/images/Horizontal-Green-Logo_comp-350x42.png 350w, /server/assets/images/Horizontal-Green-Logo_comp-300x36.png 300w, /server/assets/images/Horizontal-Green-Logo_comp-1024x122.png 1024w, /server/assets/images/Horizontal-Green-Logo_comp-768x92.png 768w, /server/assets/images/Horizontal-Green-Logo_comp.png 1400w"
                  // sizes="(max-width: 350px) 100vw, 350px"
                />
                {/* style={siteLogoStyles[site]} /> */}
              </a>
              </Navbar.Brand>
              <Navbar.Toggle />
            </div>
          </div>
          <Navbar.Collapse>
          <Nav className="flex v-center login-nav nav navbar-nav ml-auto navbar-nav">
              { 
                user ? 
                  <HeaderNavigationDropDown 
                    {...props}
                  /> : (
                  <NavItem 
                    className='flex v-center link-item cursor-pointer' 
                    style={{ height: 70, fontFamily: 'Futura Bold,Arial,sans-serif', letterSpacing: '.1em', display: 'flex' }}
                    onClick={async () => { 
                      prepareAuth0Redirect(initialUrlParams)
                      const loginOptions = { authorizationParams: { screen_hint: 'login', redirect_uri: redirectUri, login_hint: email || undefined }}
                      if (window.top !== window) {
                        window.open(`${location.protocol}//${location.host}/login${email ? `?email=${email}` : ''}`, '_blank')
                        return
                      }
                      await loginWithRedirect(loginOptions)
                    }}
                  >
                    <button 
                      className='flex v-center few-login-button'
                      style={{ 
                        height: '100%', 
                        background: 'none',
                        border: '1px solid rgb(211, 211, 211)',
                        borderRadius: 999,
                        maxHeight: 34,
                        padding: '4px 8px',
                      }}
                    >
                      <svg 
                        focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="MenuIcon"
                        style={{ width: 24, height: 24, marginRight: 8, fill: 'currentColor' }}
                      >
                        <path d="M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"></path>
                      </svg>
                      <svg focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="AccountCircleOutlinedIcon"
                        style={{ width: 24, height: 24, fill: 'currentColor' }}
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5m10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12"></path><path d="M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11"></path>
                      </svg>
                    </button>
                  </NavItem>
                )
              }
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <MainImage {...props}></MainImage>
    </div>
  )
}